// src/modules/app-views/invoices/components/InvoicesDocumentCardHeaderTitle.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Form } from 'antd';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import translateX from 'utils/translateX';
import useZustand from 'hooks/useZustand';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderInvoiceTitle = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { form } = useSimpleFormContext() || {};
  const currentPage = useZustand?.('module', 'currentPage', false);
  const data = currentPage?.data;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  // Watch recipient from form to update title dynamically
  const formRecipient = Form.useWatch('recipient', form);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const isNew = !data?._id || data?._id === 'add';

  // Use form recipient value if available, fallback to recipientDisplay/recipientEntity/recipient
  const recipientName =
    data?.recipientEntity?.fullName ||
    formRecipient?.fullName ||
    formRecipient?.name ||
    data?.recipientEntity?.name ||
    data?.recipient?.fullName ||
    data?.recipient?.name ||
    data?.recipient?.legalName;

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (isNew && !recipientName) {
    return <span className="text-muted opacity-0-7">{translateX('recipient')}</span>;
  }

  return <span>{recipientName || translateX('recipient')}</span>;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderInvoiceTitle;

// *******************************************************************************
// HELPERS
// *******************************************************************************
